module.exports = __webpack_public_path__ + "assets/img/profile-role-active.98f5eb66.svg";